import {DateTimeFormatter, DateTimeFormatterBuilder, Instant, ResolverStyle, ZoneId} from "@js-joda/core";
import {arrayExtensions} from "./Array";

declare module "@js-joda/core" {
	interface Instant {
		humanize(): string;
	}
}

const formatter = new DateTimeFormatterBuilder()
	.append(DateTimeFormatter.ISO_LOCAL_DATE)
	.appendLiteral(" ")
	.append(DateTimeFormatter.ISO_LOCAL_TIME)
	.toFormatter(ResolverStyle.SMART);

Instant.prototype.humanize = function (): string {
	const zoned = this.atZone(ZoneId.systemDefault());
	return formatter.format(zoned);
};

export const extensions = {
	load: () => {
		arrayExtensions.load();
	},
};
